module.exports = __webpack_public_path__ + "static/assets/9d1e2162775d5f74c0386a4d915af1bd.gif";